(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagna_logDialogController', Campagna_logDialogController);

    Campagna_logDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Campagna_log', 'Campagna', 'Campagnalog_tipo'];

    function Campagna_logDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Campagna_log, Campagna, Campagnalog_tipo) {
        var vm = this;

        vm.campagna_log = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.campagnas = Campagna.query();
        vm.campagnalog_tipos = Campagnalog_tipo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.campagna_log.id !== null) {
                Campagna_log.update(vm.campagna_log, onSaveSuccess, onSaveError);
            } else {
                Campagna_log.save(vm.campagna_log, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:campagna_logUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtins = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
